import { Alpha } from '@kite-js/theme-types';

const alpha: Alpha = {
    20: 'rgba(0, 0, 0, .02)',
    50: 'rgba(0, 0, 0, .05)',
    100: 'rgba(0, 0, 0, .1)',
    150: 'rgba(0, 0, 0, .15)',
    200: 'rgba(0, 0, 0, .3)',
    300: 'rgba(0, 0, 0, .4)',
    500: 'rgba(0, 0, 0, .5)',
    800: 'rgba(0, 0, 0, .8)',
};

export default alpha;
